import { render, staticRenderFns } from "./SimNumeroFormGeneral.vue?vue&type=template&id=76ad0906&"
import script from "./SimNumeroFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./SimNumeroFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('76ad0906', component.options)
    } else {
      api.reload('76ad0906', component.options)
    }
    module.hot.accept("./SimNumeroFormGeneral.vue?vue&type=template&id=76ad0906&", function () {
      api.rerender('76ad0906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/InventarioSim/SimNumeroFormGeneral.vue"
export default component.exports